module.exports = __webpack_public_path__ + "img/UTCORA-8.871051cb.jpg";